export default __webpack_public_path__ + "static/imgBackgroundTablet-a5adaf8918250fd6765d28866e66a1fe.png";